import axios from "axios";

// ✅ Utilisation de la variable d'env Webpack (REACT_APP_)
// On s'assure que baseURL pointe vers le préfixe /api
const API_URL = process.env.REACT_APP_API_URL || "https://souqi-api.onrender.com/api";

const axiosAdmin = axios.create({
  baseURL: API_URL,
  withCredentials: false, // On reste sur du JWT pur sans cookies
});

// 🔐 Intercepteur : injecte automatiquement le token admin
axiosAdmin.interceptors.request.use(
  (config) => {
    // On récupère le token peu importe le nom de clé utilisé précédemment
    const token = localStorage.getItem("adminToken") || localStorage.getItem("admin_token");

    if (token) {
      // ✅ Correction de délicatesse : On assigne le header sans écraser le reste
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosAdmin;